module.exports = function (eventContext) {
    return {
        event: 'PDPlinkClick',
        eventContext
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/cards/detail/product/atm-mapper-pdp-link-click.js
 **/